import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export interface FormData {
  courseName?: string;
  validationType?: FieldSelects['validationType'];
  rapOption?: FieldSelects['rapOption'];
  examGrade?: string | null;
  courseGrade?: string | null;
  externalGrade?: string | null;
  externalCourseName?: string | null;
  institution?: string | null;
  description?: string;
  code?: string;
  doc?: {
    name: string;
    url: string;
  };
  supplementaryFiles?: {
    name: string;
    extension: string;
    url: string;
  }[];
}

export interface FieldSelects {
  validationType: { label: string; value: 'internal' | 'rap' | 'external' };
  rapOption: { label: string; value: 'validation' | 'proficiency' };
}

const useTextValidationType = () => {
  const { t } = useTranslation();
  const prefix = 'modalValidationType';

  const texts = useMemo(
    () => ({
      title: t(`${prefix}.title`),
      subTitle: t(`${prefix}.subTitle`),
      courseNameLabel: t(`${prefix}.courseNameLabel`),
      courseCodeLabel: t(`${prefix}.courseCodeLabel`),
      examGradeLable: t(`${prefix}.examGradeLabel`),
      courseGradeLabel: t(`${prefix}.courseGradeLabel`),
      invalidGrade: t(`${prefix}.invalidGrade`),
      description: {
        label: t('common.forms.description'),
        placeholder: t(`common.forms.descriptionPlaceholder`),
      },
      courseGradeForExternal: {
        tooltip: t(`${prefix}.courseGradeTooltip`),
      },
      externalGrade: {
        label: t('common.forms.externalGrade'),
        tooltip: t('common.forms.externalGradeTooltip'),
      },
      externalCourseName: {
        label: t('common.forms.externalCourseName'),
      },
      institution: {
        label: t('terms:institution.single'),
      },
      validationType: {
        selectLabel: t(`${prefix}.validationType.selectLabel`),
        internal: t(`${prefix}.validationType.internal`),
        rap: t(`${prefix}.validationType.rap`),
        external: t(`${prefix}.validationType.external`),
      },
      rapType: {
        selectLabel: t(`${prefix}.rapType.selectLabel`),
        validation: t(`${prefix}.rapType.validation`),
        proficiency: t(`${prefix}.rapType.proficiency`),
      },
      uploadFile: {
        label: t(`${prefix}.uploadFile.label`),
        button: t(`${prefix}.uploadFile.button`),
      },
      dowmnloadFile: {
        label: t(`${prefix}.dowmnloadFile.label`),
        button: t(`${prefix}.dowmnloadFile.button`),
      },
      actions: {
        cancel: t(`${prefix}.actions.cancel`),
        confirm: t(`${prefix}.actions.confirm`),
        close: t(`${prefix}.actions.close`),
      },
      required: t('common.validations.required'),
      toast: {
        success: t(`${prefix}.toast.success`),
        error: t(`${prefix}.toast.error`),
      },
    }),
    [t],
  );

  const validationOptions: FieldSelects['validationType'][] = [
    { label: texts.validationType.internal, value: 'internal' },
    { label: texts.validationType.rap, value: 'rap' },
    { label: texts.validationType.external, value: 'external' },
  ];

  const rapOptions: FieldSelects['rapOption'][] = [
    { label: texts.rapType.validation, value: 'validation' },
    { label: texts.rapType.proficiency, value: 'proficiency' },
  ];

  return {
    texts,
    validationOptions,
    rapOptions,
  };
};

export default useTextValidationType;
